module.exports = __webpack_public_path__ + "img/temp-storage.0cc1010c.svg";